import { Link } from "react-router-dom";

/**
 * Breadcrumbs — every segment except the last is a Link. The last segment
 * represents the current page and renders as plain text. The "›" separator
 * uses the brand accent gold (#C9A84C).
 *
 * Usage: <Breadcrumbs items={[{label:"Home", to:"/"}, {label:"Employees", to:"/employees"}, {label:"Aakash Sharma — Competency Card"}]} />
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="px-4 md:px-10 pt-4 pb-1 text-xs"
    >
      <ol className="flex items-center flex-wrap gap-x-1.5 gap-y-1">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          // Use the destination path (or label as fallback) so keys stay stable
          // when a caller reorders/replaces breadcrumbs.
          const key = it.to || `${it.label}-${i}`;
          return (
            <li key={key} className="flex items-center gap-1.5">
              {isLast || !it.to ? (
                <span
                  className="font-medium text-[#1A1A1A] truncate max-w-[280px]"
                  data-testid={`breadcrumb-current`}
                  aria-current="page"
                  title={it.label}
                >
                  {it.label}
                </span>
              ) : (
                <Link
                  to={it.to}
                  data-testid={`breadcrumb-link-${it.to.replace(/\//g, "-").replace(/^-/, "")}`}
                  className="text-[#666666] hover:text-[#0D0D0D] hover:underline underline-offset-2"
                >
                  {it.label}
                </Link>
              )}
              {!isLast && (
                <span
                  aria-hidden="true"
                  className="text-[#C9A84C] font-semibold select-none"
                >
                  ›
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
